
import { EAuthMethod, EAuthMode } from '@/helpers/enums'
import { validateEnum } from '@/helpers/index'

export default {
  name: 'LoginButton',
  props: {
    type: {
      validator(value) {
        return validateEnum(value, EAuthMethod)
      },
      default: EAuthMethod.EMAIL
    },
    text: {
      type: String,
      default: ''
    },
    isAlert: Boolean,
    isPrimary: Boolean
  },
  data() {
    return { authMode: EAuthMode.LOGIN }
  },
  computed: {
    hasAction() {
      const loginMethodsWithForms = [EAuthMethod.AUTH0, EAuthMethod.LINKEDIN, EAuthMethod.GOOGLE]
      return loginMethodsWithForms.includes(this.type)
    },
    buttonAction() {
      return this.hasAction ? `/v1/api/social/${this.type}` : ''
    }
  }
}
